<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu header-user">
          <zjy-avatar class="avatar" icon="user" :url="userInfo.avatar" :name="userInfo.name"/>
          <span>{{ userInfo.name }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
<!--          <a-menu-item key="0" v-if="$store.getters.userInfo.id">-->
<!--            <router-link to="/userCenter">-->
<!--              <a-icon type="user"/>-->
<!--              <span>个人中心</span>-->
<!--            </router-link>-->
<!--          </a-menu-item>-->
<!--          <a-menu-divider/>-->
          <template v-if="userInfo.id">
            <a-menu-item key="3">
              <a href="javascript:;" @click="handleLogout">
                <a-icon type="logout"/>
                <span>退出登录</span>
              </a>
            </a-menu-item>
          </template>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ZjyAvatar from '@/components/zjy/ZjyAvatar.vue'

export default {
  name: 'UserMenu',
  components: {ZjyAvatar},
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    ...mapActions(['Logout']),

    handleLogout () {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          return this.Logout().then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 16)
          }).catch(err => {
            this.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header-user {
  display: flex;
  align-items: center;
  .avatar {
    margin-right: 10px;
  }
}
</style>
